import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import BrandLogo from "../components/BrandLogo";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await login(email, password);
        setLoading(false);
        if (res.ok) {
            toast.success("Welcome back");
            nav("/dashboard");
        } else {
            toast.error(res.error || "Login failed");
        }
    };

    return (
        <div className="min-h-screen grid grid-cols-1 md:grid-cols-2 bg-white">
            <div className="hidden md:block relative">
                <img src="https://images.pexels.com/photos/25492353/pexels-photo-25492353.jpeg" alt="" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-[#0F1E3D]/40" />
                <div className="relative h-full p-12 flex flex-col justify-between text-white">
                    <Link to="/" className="flex items-center gap-2">
                        <BrandLogo height={40} className="brightness-0 invert" />
                    </Link>
                    <div>
                        <p className="overline text-white/70">Welcome back</p>
                        <h2 className="font-serif text-4xl mt-3 leading-tight max-w-md">
                            Every case <span className="italic">starts</span> with the right letter.
                        </h2>
                    </div>
                </div>
            </div>
            <div className="flex items-center justify-center p-8">
                <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="login-form">
                    <div>
                        <p className="overline">Sign in</p>
                        <h1 className="font-serif text-4xl mt-3 leading-tight">Open your workbench.</h1>
                    </div>
                    <div className="space-y-3">
                        <div>
                            <Label htmlFor="email">Email</Label>
                            <Input data-testid="login-email" id="email" type="email" required value={email}
                                onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-11" />
                        </div>
                        <div>
                            <Label htmlFor="pw">Password</Label>
                            <Input data-testid="login-password" id="pw" type="password" required value={password}
                                onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-11" />
                        </div>
                    </div>
                    <Button data-testid="login-submit" type="submit" disabled={loading}
                        className="w-full h-11 bg-[#0F1E3D] hover:bg-[#1A2C57] rounded-md">
                        {loading ? "Signing in…" : "Sign in"}
                    </Button>
                    <p className="text-sm text-slate-600 text-center">
                        New here? <Link data-testid="link-register" to="/register" className="text-[#2563EB] hover:underline">Create an account</Link>
                    </p>
                </form>
            </div>
        </div>
    );
}
